import { History } from "history";

export const updateQueryParams = (
  query: string,
  router: History<unknown>,
  pathname: string
) => {
  if (window.history && window.history.replaceState) {
    let data =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    if (query.trim().length > 0) {
      data += "?" + query;
    }
    data += window.location.hash;
    window.history.replaceState({ path: data }, "", data);
  } else {
    router.replace({
      pathname,
      search: query,
    });
  }
};
